/* eslint-disable indent */
import R from "ramda";

import * as actionTypes from "../actions/actionTypes";
import * as images from "@/constants/images";
import * as routes from "@/constants/routes";

const initialState = {
  loading: false,
  error: "",
  canvas: {},
  canvases: [
    {
      id: routes.TEAM_CANVAS,
      image: images.TEAM_CANVAS_IMAGE,
      en_name: "Team Canvas",
      kh_name: "សន្លឹកកិច្ចការរៀបចំក្រុម",
      en_short_description:
        "Most important thing to talk about in the team to make sure your work in the group is productive, happy and stress-free.",
      kh_short_description:
        "វាជាសន្លឹកកិច្ចការដែលអ្នកត្រូវ​និយាយពីចំនុចសំខាន់ៗក្នុង​ការងារក្រុមដើម្បីឲ្យ​ប្រាកដថា​ក្រុមការ​ងារ​របស់អ្នក(មាន)​ផលិតភាពខ្ពស់​ សប្បាយចិត្ត និង​មិន​មានភាពតានតឹង។",
      en_description:
        "Most important thing to talk about in the team to make sure your work in the group is productive, happy and stress-free.",
      kh_description:
        "វាជាសន្លឹកកិច្ចការដែលអ្នកត្រូវ​និយាយពីចំនុចសំខាន់ៗក្នុង​ការងារក្រុមដើម្បីឲ្យ​ប្រាកដថា​ក្រុមការ​ងារ​របស់អ្នក(មាន)​ផលិតភាពខ្ពស់​ សប្បាយចិត្ត និង​មិន​មានភាពតានតឹង។",
      blocks: [
        {
          id: `${routes.TEAM_CANVAS}-people-and-roles`,
          icon: images.PEOPLES_AND_ROLE_ICON,
          title: "ឈ្មោះសមាជិក និង តួនាទី | People and Roles",
          questionEnglish:
            "What are our names and the roles we have in the team? What are we called as a team?",
          questionKhmer:
            "តើសមាជិកក្រុមមានឈ្មោះអ្វីខ្លះ ហើយ​ម្នាក់ៗមាន​តួនាទីជាអ្វី? តើក្រុមរបស់​យើង​ឈ្មោះអ្វី?"
        },
        {
          id: `${routes.TEAM_CANVAS}-values`,
          icon: images.VALUE_ICON,
          title: "គុណតម្លៃ  | Values",
          questionEnglish:
            "What do we stand for? What are guiding principles? What are our common values that we want to be at the core of our team?",
          questionKhmer:
            "តើគោលជំហររបស់យើងគឺអ្វី? តើគោលការណ៏ត្រួសត្រាយផ្លូវរបស់យើង​មាន​អ្វីខ្លះ? តើអ្វីជា​គុណតម្លៃរួមរបស់យើងដែល​យើង​ចង់ដាក់វា​ជាសកម្មភាពស្នូលក្នុងក្រុម?"
        },
        {
          id: `${routes.TEAM_CANVAS}-purpose`,
          icon: images.PURPOSE_ICON,
          title: "គោលបំណង |  Purpose",
          questionEnglish:
            "What you as a group really want to achieve? What is our key goal that feasible, measurable and time-bounded?",
          questionKhmer:
            "តើក្រុមទាំងមូល​ចង់សម្រេចកិច្ចការអ្វីឲ្យប្រាកដ? តើអ្វីជាគោលដៅសំខាន់របស់យើងដែល​យើង​មាន​លទ្ធភាពធ្វើ អាចវាស់វែងបាន និង​មាន​ពេលវេលាជាក់លាក់?"
        },
        {
          id: `${routes.TEAM_CANVAS}-common-goals`,
          icon: images.COMMON_GOAL_ICON,
          title: "គោលដៅរួម | Common Goals",
          questionEnglish:
            "What you as a group really want to achieve? What is our key goal that feasible, measurable and time-bounded?",
          questionKhmer:
            "តើក្រុមទាំងមូល​ចង់សម្រេចកិច្ចការអ្វីឲ្យប្រាកដ? តើអ្វីជាគោលដៅសំខាន់របស់យើងដែល​យើង​មាន​លទ្ធភាពធ្វើ អាចវាស់វែងបាន និង​មាន​ពេលវេលាជាក់លាក់? What you as a group really want to achieve? What is our key goal that feasible, measurable and time-bounded?"
        },
        {
          id: "team-canvas-personal-goals",
          icon: images.PERSONAL_GOAL_ICON,
          title: "គោលដៅផ្ទាល់ខ្លួន |  Personal Goals",
          questionEnglish:
            "What are our individual personal goals? Are there personal agendas that we want to open up?",
          questionKhmer:
            "តើអ្វីខ្លះជាគោលដៅផ្ទាល់ខ្លួនរបស់យើង​ម្នាក់ៗ? តើ​មាន​របៀបវារៈផ្ទាល់ខ្លួនអ្វីខ្លះដែល​យើង​ចង់​បង្ហាញ?"
        },
        {
          id: `${routes.TEAM_CANVAS}-role-and-activity`,
          icon: images.RULE_AND_ACTIVITY_ICON,
          title: "ច្បាប់ទម្លាប់ និង​សកម្មភាព |  Rules & Activities",
          questionEnglish:
            "What are the rules we want to introduce after doing this session? How do we communicate and keep everyone up to date? How do we make decisions? How do we execute and evaluate what we do?",
          questionKhmer:
            "តើអ្វីខ្លះជា​ច្បាប់ទម្លាប់របស់យើងដែល​ត្រូវ​ណែនាំបន្ទាប់ពី​ការជួបជុំមួយនេះ? តើយើងទាក់ទងគ្នា និងឲ្យ​ដំណឹងថ្មីៗទៅគ្នាដោយ​របៀបណា? តើយើង​ធ្វើការ​សម្រេចចិត្តដោយ​របៀបណា? តើយើង​អនុវត្ត និង​វាយតម្លៃសកម្មភាពរបស់ពួកយើង​ដោយ​របៀបណា?"
        },
        {
          id: `${routes.TEAM_CANVAS}-strengths-assets`,
          icon: images.STRENGTH_AND_ASSET_ICON,
          title: "ចំនុចខ្លាំង និងទ្រព្យ | Strengths & Assets",
          questionEnglish:
            "What are the skills that we have in the team that will help us achieve our goals? What are the interpersonal/soft skills that we have? What are we good at, individually and as a team?",
          questionKhmer:
            "តើយើង​មាន​ជំនាញអ្វីខ្លះនៅក្នុង​ក្រុមដែលអាចជួយ​ពួកយើង​សម្រេច​គោលដៅ​របស់យើង​បាន?តើ​យើង​មាន​ជំនាញទន់អ្វីខ្លះ? ជា​បុគ្គល តើយើងពូកែខាងអ្វី ហើយ​ជាក្រុម ពួកយើងពូកែខាងអ្វី?"
        },
        {
          id: `${routes.TEAM_CANVAS}-weaknesses-and-failures`,
          icon: images.STRENGTH_AND_ASSET_ICON,
          title: "ចំនុចខ្សោយ និង​ការបរាជ័យ | Weaknesses & Failures",
          questionEnglish:
            "What were the weaknesses we had? What failures or challenges did we experience? Why? What can we learn from these to make improvements in the future?",
          questionKhmer:
            "តើ​ចំនុចខ្សោយអ្វីខ្លះដែលយើងធ្លាប់មាន? តើបរាជ័រ ឬបញ្ហាប្រឈមអ្វីខ្លះដែលយើងបានជួបប្រទះ? មូលហេតុអ្វី? តើយើងអាចរៀនពី​ចំនុចទាំងនេះ​អ្វីខ្លះដើម្បីធ្វើឲ្យមានភាពប្រសើរឡើងនាពេលអនាគត?"
        },
        {
          id: `${routes.TEAM_CANVAS}-needs-and-expectation`,
          icon: images.NEED_AND_EXPECTATION_ICON,
          title: "តម្រូវការ និង​ការរំពឹងទុក |  Needs & Expectations",
          questionEnglish:
            "What are the weaknesses we have, individually and as a team? What our teammates should know about us? What are some obstacles we see ahead us that we are likely to face?",
          questionKhmer:
            "ជាបុគ្គល តើយើងខ្សោយខាងអ្វី ហើយជាក្រុម ពួកយើងខ្សោយខាងអ្វី? តើក្រុមការងារគួរតែដឹងអ្វីខ្លះពីយើង?​ តើឧបសគ្គអ្វីខ្លះដែល​យើង​ឃើញមុនថាយើងនឹងអាចជួបប្រទះ?"
        }
      ]
    },
    {
      id: routes.CUSTOMER_DISCOVERY,
      image: images.CUSTOMER_DISCOVERY_IMAGE,
      en_name: "Customer Persona",
      kh_name: "ពត៌មានលម្អិតរបស់អតិថិជន",
      en_short_description:
        "Understand and empathize with your customer with a representation of your ideal customer based on your customer discovery research.",
      kh_short_description:
        "វាជាសន្លឹកកិច្ចការដែលធ្វើឲ្យអ្នកយល់កាន់តែច្បាស់ពីអតិថិជនតាមរយៈការស្រាវជ្រាវ។",
      en_description:
        "Understand and empathize with your customer with a representation of your ideal customer based on your customer discovery research.",
      kh_description:
        "វាជាសន្លឹកកិច្ចការដែលធ្វើឲ្យអ្នកយល់កាន់តែច្បាស់ពីអតិថិជនតាមរយៈការស្រាវជ្រាវ។",
      blocks: [
        {
          id: routes.CUSTOMER_DISCOVERY + "-demographic-information",
          title: "ព័ត៌មានប្រជាសាស្ត្រ | Demographic Information"
        },
        {
          id: routes.CUSTOMER_DISCOVERY + "-characteristics",
          title: "បុគ្គលិកលក្ខណៈ | Characteristics"
        },
        {
          id: routes.CUSTOMER_DISCOVERY + "-Obstacles",
          title: "ឧបសគ្គ/បញ្ហាប្រឈម | Obstacles"
        },
        {
          id: routes.CUSTOMER_DISCOVERY + "-goals",
          title: "គោលដៅ | Goals"
        }
      ]
    },
    {
      id: routes.COMPETITION_MATRIX,
      image: images.COMPETITION_ANALYSIS_IMAGE,
      en_name: "Competition Analysis",
      kh_name: "ការវិភាគលើ​ដៃគូរប្រកួតប្រជែង",
      en_short_description:
        "Research competitors to discover what customers love and don't love and where there are gaps in the market.",
      kh_short_description:
        "វាជាការស្រាវជ្រាវលើ​ដៃគូប្រកួតប្រជែងរបស់អ្នក​ដើម្បីរក​ឲ្យ​ឃើញ​ពី​អ្វីដែល​អតិថិជន​ស្រលាញ់ និង​មិន​ស្រលាញ់ ហើយ​និងគម្លាតដែលមាន​ក្នុងទីផ្សារ។",
      en_description:
        "Research competitors to discover what customers love and don't love and where there are gaps in the market.",
      kh_description:
        "វាជាការស្រាវជ្រាវលើ​ដៃគូប្រកួតប្រជែងរបស់អ្នក​ដើម្បីរក​ឲ្យ​ឃើញ​ពី​អ្វីដែល​អតិថិជន​ស្រលាញ់ និង​មិន​ស្រលាញ់ ហើយ​និងគម្លាតដែលមាន​ក្នុងទីផ្សារ។",
      blocks: [
        {
          id: `${routes.COMPETITION_MATRIX}-01`,
          title: "លក្ខណៈពិសេស ទី០",
          type: "textarea",
          state: "invisible"
        },
        {
          id: `${routes.COMPETITION_MATRIX}-02`,
          title: "លក្ខណៈពិសេស ទី១",
          type: "textarea",
          isFeature: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-03`,
          title: "លក្ខណៈពិសេស ទី២",
          type: "textarea",
          isFeature: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-04`,
          title: "លក្ខណៈពិសេស ទី៣",
          type: "textarea",
          isFeature: true
        },

        {
          id: `${routes.COMPETITION_MATRIX}-05`,
          title: "គូរប្រកួតប្រជែង​ ទី១",
          type: "textarea",
          isCompetition: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-06`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-02`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-07`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-03`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-08`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-04`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-09`,
          title: "គូរប្រកួតប្រជែង ទី២",
          type: "textarea",
          isCompetition: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-010`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-02`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-011`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-03`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-012`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-04`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-013`,
          title: "គូរប្រកួតប្រជែង ទី៣",
          type: "textarea",
          isCompetition: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-014`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-02`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-015`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-03`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-016`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-04`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-017`,
          title: "ផលិតផល / សេវាកម្មរបស់យើង",
          type: "textarea",
          isCompetition: true
        },
        {
          id: `${routes.COMPETITION_MATRIX}-018`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-02`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-019`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-03`
        },
        {
          id: `${routes.COMPETITION_MATRIX}-020`,
          title: "Checkbox",
          type: "checkbox",
          parent: `${routes.COMPETITION_MATRIX}-04`
        }
      ]
    },
    {
      id: routes.IDEA_GENERATION_CANVAS,
      image: images.IDEA_GENERATION_IMAGE,
      en_name: "Idea Generation",
      kh_name: "សន្លឹកកិច្ចការបង្កើតគំនិត",
      en_short_description:
        "To create an innovative idea, start with as many crazy ideas as possible. Then combine ideas to improve them. Then select your final idea.",
      kh_short_description:
        "ដើម្បីបង្កើតគំនិតច្ថៃប្រឌិតមួយបាន យើងគួរចាប់ផ្តើមពីការសរសេរគំនិតដែលយើងនឹកឃើញផ្សេងៗឲ្យច្រើនបំផុត តាមដែល អាចធ្វើទៅបាន។ បន្ទាប់មក យកគំនិតទាំងនេះដាក់បញ្ចូលគ្នា ហើយច្នៃវាឲ្យកាន់តែល្អជាងមុន។ ចុងក្រោយរើសយក...",
      en_description:
        "To create an innovative idea, start with as many crazy ideas as possible. Then combine ideas to improve them. Then select your final idea.",
      kh_description:
        "ដើម្បីបង្កើតគំនិតច្ថៃប្រឌិតមួយបាន យើងគួរចាប់ផ្តើមពីការសរសេរគំនិតដែលយើងនឹកឃើញផ្សេងៗឲ្យច្រើនបំផុត តាមដែល អាចធ្វើទៅបាន។ បន្ទាប់មក យកគំនិតទាំងនេះដាក់បញ្ចូលគ្នា ហើយច្នៃវាឲ្យកាន់តែល្អជាងមុន។ ចុងក្រោយរើសយក គំនិតដែលល្អចុងក្រោយ។",
      blocks: [
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-00",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 1 | គំនិត​ទី ១"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-01",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 2 | គំនិត​ទី ២"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-02",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 3 | គំនិត​ទី ៣"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-10",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 4 | គំនិត​ទី ៤"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-11",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 5 | គំនិត​ទី ៥"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-12",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 6 | គំនិត​ទី ៦"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-20",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 7 | គំនិត​ទី ៧"
        },
        {
          id: routes.IDEA_GENERATION_CANVAS + "-section-21",
          icon: images.IDEA_AND_GENERATION,
          title: "Idea 8 | គំនិត​ទី ៨"
        }
      ]
    },
    {
      id: routes.PROTOTYPE_CANVAS,
      image: images.PROTOTYPING_IMAGE,
      en_name: "Prototyping & Testing",
      kh_name: "គំរូផលិតផល និង ការសាកល្បង",
      en_short_description:
        "Create a physical prototype and test this with customers. Get their feedback. Make changes to improve your design.",
      kh_short_description:
        "ក្រុមនីមួយៗត្រូវ បង្កើតគំរូផលិតផលមួយហើយ ធ្វើការសាកល្បងជាមួយអតិថិជនគោលដៅ។ កត់ទុករាល់ មតិយោបលរបស់ពួកគេ ហើយ ធ្វើការ កែសម្រួលផលិតផលរបស់អ្នកឲ្យ កាន់តែប្រសើរ។",
      en_description:
        "Create a physical prototype and test this with customers. Get their feedback. Make changes to improve your design.",
      kh_description:
        "ក្រុមនីមួយៗត្រូវ បង្កើតគំរូផលិតផលមួយហើយ ធ្វើការសាកល្បងជាមួយអតិថិជនគោលដៅ។ កត់ទុករាល់ មតិយោបលរបស់ពួកគេ ហើយ ធ្វើការ កែសម្រួលផលិតផលរបស់អ្នកឲ្យ កាន់តែប្រសើរ។",
      blocks: [
        {
          id: routes.PROTOTYPE_CANVAS + "-section-00",
          title: "តើការធ្វើការលើគំនិតនេះ មានចំណុចល្អអ្វីខ្លះ?"
        },
        {
          id: routes.PROTOTYPE_CANVAS + "-section-01",
          title: "មតិពីអតិថិជន | Feedback from Customers"
        },
        {
          id: routes.PROTOTYPE_CANVAS + "-section-02",
          title:
            "ការកែសម្រួលដោយផ្អែកលើមតិរបស់អតិថិជន | Changes Based on Customers  Feedback"
        }
      ]
    },
    {
      id: routes.PEER_FEEDBACK_CANVAS,
      image: images.PEER_FEEDBACK_IMAGE,
      en_name: "Peer Feedback​",
      kh_name: "មតិយោបល់ពីគ្នាទៅវិញទៅមក",
      en_short_description:
        "Learn from feedback on your past experiences and develop your constructive feedback and analytical thinking skills.",
      kh_short_description:
        "វាជា​ការរៀនសូត្រពី​មិតិយោបលដែល​អ្នកទទួលបានពី​បទពិសោធន៍កន្លងមក ហើយ​អភិវឌ្ឍន៍មិតិរិះគន់ស្ថាបនារបស់អ្នក និង​ជំនាញវិភាគរបស់អ្នក។",
      en_description:
        "Learn from feedback on your past experiences and develop your constructive feedback and analytical thinking skills.",
      kh_description:
        "វាជា​ការរៀនសូត្រពី​មិតិយោបលដែល​អ្នកទទួលបានពី​បទពិសោធន៍កន្លងមក ហើយ​អភិវឌ្ឍន៍មិតិរិះគន់ស្ថាបនារបស់អ្នក និង​ជំនាញវិភាគរបស់អ្នក។",
      blocks: [
        {
          id: routes.PEER_FEEDBACK_CANVAS + "-section-00",
          questionEnglish: "What is good about this idea? Why?",
          questionKhmer: "តើគំនិតនេះមានចំណុចល្អអ្វីខ្លះ? ហេតុអ្វី?"
        },
        {
          id: routes.PEER_FEEDBACK_CANVAS + "-section-10",
          questionEnglish: "What could be improved? How?",
          questionKhmer: "តើចំណុចអ្វីខ្លះគួរកែតម្រូវ? ដោយរបៀបណា?"
        },
        {
          id: routes.PEER_FEEDBACK_CANVAS + "-section-11",
          questionEnglish: "What did you learn from working with partner team?",
          questionKhmer: "តើអ្នករៀនបានអ្វីខ្លះពីការធ្វើការជាមួយក្រុមដទៃ?"
        }
      ]
    },
    {
      id: routes.BUSINESS_MODEL_CANVAS,
      image: images.BUSINESS_MODEL_CANVAS_IMAGE,
      en_name: "Business Model Canvas",
      kh_name: "សន្លឹកកិច្ចការគំរូអាជីវកម្ម",
      en_short_description:
        "The business model canvas is a great tool to help you understand a business model in a straightforward, structured way. Using this canvas will lead to insights about the customers you serve...",
      kh_short_description:
        "សន្លឹកកិច្ចការគំរូអាជីវកម្ម គឺជា​បច្ចេកទេសដ៏អស្ចារ្យដែលជួយអ្នក​ឲ្យយល់កាន់តែច្បាស់ពីអាជីវកម្មក្នុងទម្រង់ច្បាស់លាស់ និង​មាន​រចនាសម័្ពន្ធត្រឹមត្រូវ។ ការប្រើសន្លឹកកិច្ចការនេះ នឹងជួយនាំផ្លូវអ្នក​ឲ្យមើលឃើញច្បាស់ពីថាអ្នណាខ្លះជាអតិថិជនគោលដៅ...",
      en_description:
        "The business model canvas is a great tool to help you understand a business model in a straightforward, structured way. Using this canvas will lead to insights about the customers you serve, what value propositions are offered through what channels, and how your company makes money. You can use the business model canvas to understand your own business model or that of a competitor!",
      kh_description:
        "សន្លឹកកិច្ចការគំរូអាជីវកម្ម គឺជា​បច្ចេកទេសដ៏អស្ចារ្យដែលជួយអ្នក​ឲ្យយល់កាន់តែច្បាស់ពីអាជីវកម្មក្នុងទម្រង់ច្បាស់លាស់ និង​មាន​រចនាសម័្ពន្ធត្រឹមត្រូវ។ ការប្រើសន្លឹកកិច្ចការនេះ នឹងជួយនាំផ្លូវអ្នក​ឲ្យមើលឃើញច្បាស់ពីថាអ្នណាខ្លះជាអតិថិជនគោលដៅ គុណតម្លៃនៃអាជីវកម្មត្រូវ​ផ្តល់ទៅអតិថិជនតាមរយៈបណ្តាញមួយណា និង របៀបរកចំណូលរបស់អាជីវកម្ម។ វាក៏ជួយអ្នកឲ្យ​ស្គាល់ពីគូប្រកួតប្រជែងឲ្យកាន់តែច្បាស់ដែរ។",
      blocks: [
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-key-partners",
          title: "ដៃគូអាជីវកម្មសំខាន់ៗ | Key Partners",
          description: {
            title:
              "តើអ្នកណាខ្លះជាដៃគូអាជីវកម្មសំខាន់ៗរបស់យើង? | Who are our Key Partners?<br>តើអ្នកណាខ្លះជាអ្នកផ្គត់ផ្គង់សំខាន់របស់យើង? | Who are our key suppliers?<br>តើធនធានសំខាន់ៗអ្វីខ្លះដែលយើងទទួលបានពីដៃគូរបស់យើង? | Which Key Resources are we acquiring from partners? <br>តើសកម្មភាពសំខាន់ៗអ្វីខ្លះដែលដៃគូរបស់យើងផ្តល់ឲ្យ? | Which Key Activities do partners perform?<br>កត្តាការលើកទឹកចិត្តភាពជាដៃគូអាជីវកម្ម | MOTIVATIONS FOR PARTNERSHIPS:<br>ទទួល​បាន​ការ​បញ្ចុះតម្លៃពី​ដៃគូរអាជីវកម្ម | Optimization and economy<br>ជួយកាត់បន្ថយហានិភ័យ ក្នុង​ស្ថានភាពមិនច្បាស់លាស់ | Reduction of risk and uncertainty<br>ការទាញយកធនធានឬសកម្មភាពជាក់លាក់ណាមួយពីគ្នាទៅវិញទៅមក | Acquisition of particular resources and activities"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-key-activities",
          title: "សកម្មភាពសំខាន់ៗ | Key Activities",
          description: {
            title:
              "ដើម្បីបង្កើតគុណតម្លៃនៃអាជីវកម្ម (Value Propositions) របស់យើង តើយើង​ចាំបាច់ត្រូវធ្វើសកម្មភាពអ្វីខ្លះ? | What Key Activities do our Value Propositions require?<br>តើយើងត្រូវធ្វើ​អ្វីខ្លះដើម្បីឲ្យ​ផលិតផល ឬសេវាកម្មរបស់យើង​ទៅដល់ដៃអតិថិជន? | Our Distribution Channels?<br>តើយើងត្រូវធ្វើអ្វីខ្លះដើម្បីបង្កើត​ទំនាក់ទំនងល្អ ជាមួយអតិថិជនរបស់យើង? | Customer Relationships?<br>តើយើងត្រូវធ្វើអ្វីខ្លះដើម្បីបង្កើត និងបង្កើនលំហូចំណូល? | Revenue Streams<br>ប្រភេទ​សកម្មភាពសំខាន់ៗ CATEGORIES ៖ <br> &nbsp &nbsp &nbsp &nbsp ផលិតកម្ម | Production<br> &nbsp &nbsp &nbsp &nbsp ដំណោះស្រាយបញ្ហា| Problem Solving<br> &nbsp &nbsp &nbsp &nbsp វេទិកា/បណ្តាញ | Platform/Network"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-key-resources",
          title: "ធនធានសំខាន់ៗ | Key Resources",
          description: {
            title:
              "តើយើងត្រូវមានធនធានសំខាន់ៗអ្វីខ្លះសម្រាប់បង្កើតគុណតម្លៃ អាជីវកម្ម (Value Propositions)​ បណ្តាញចែកចាយ ទំនាក់ទំនងជាមួយអតិថិជន និង លំហូចំណូលរបស់យើង? What Key Resources do our Value Propositions require? Our Distribution Channels? Customer Relationships?Revenue Streams?<br>ប្រភេទនៃធនធាន Types of Resources៖ ធនធានរូបវ័ន្ត (Physical), ធនធានបញ្ញា - ប៉ាតង់ម៉ាក, សិទ្ធថងចម្លង​, ទិន្នន័យ (Intellectual - brand, patent, copy rights, data), ធនធានមនុស្ស (human), ធនធានហិរញ្ញវត្ថុ (financial)"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-value-propositions",
          title: "គុណតម្លៃនៃអាជីវកម្ម |  Value Propositions",
          description: {
            title:
              "ហេតុអ្វីបានជាអតិថិជនទិញផលិតផល ឬសេវាកម្មរបស់យើង? តើ​ផលិតផល ឬសេវាកម្មរបស់យើង​មាន​លក្ខណៈពិសេសអ្វីខ្លះ ដែលពិសេសឬប្រសើរជាងដៃគូរប្រកួត​ប្រជែង? What value do we deliver to the customer?<br>តើយើងកំពុងតែជួយដោះស្រាយបញ្ហាអ្វីខ្លះដល់អតិថិជន?Which one of our customer’s problems are we helping to solve?<br>តើផលិតផលនិងសេវាកម្មអ្វីខ្លះដែលយើងផ្តល់ឲ្យទៅតាមប្រភេទអតិថិជននីមួយៗ?​What bundles of products and services are we offering to each Customer Segment?<br>តើយើងត្រូវធ្វើអ្វីខ្លះដើម្បីបំពេញតម្រូវការអតិថិជន?Which customer needs are we satisfying?គុណតម្លៃនៃអាជីវកម្មសំដៅលើលក្ខណៈពិសេសនានាដូចជា៖ Characteristics:",
            subDescription: [
              {
                title: "ភាពថ្មី​ Newness",
                description:
                  "ដំណើរការនៃ​ផលិតផល ឬសេវាកម្ម Performance<br>ការផ្លាស់ប្តូរតាមតម្រូវការអតិថិជន Customization<br>ការបំពេញការងារឲ្យរួចរាល់  “Getting the job done”<br>ការរចនា “Design”<br>ម៉ាកសញ្ញា”Brand/Status"
              },
              {
                title: "តម្លៃ Price",
                description:
                  "ការកាត់ចំនាយ Cost Reduction<br>ការកាត់បន្ថយហានិភ័យ Risk Reduction<br>ការដែល​អាចប្រើ​ប្រាស់​បាន Accessibility<br>ភាពងាយស្រួល Convenience/Usability"
              }
            ]
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-customer-relationships",
          title: "ការបង្កើតទំនាក់ទំនងជាមួយអតិថិជន |  Customer Relationships",
          description: {
            title:
              "តើទំនាក់ទំនងប្រភេទណាខ្លះដែលអតិថិជន ចង់បាន? តើប្រភេទទំនាក់ទំនងណាខ្លះ ដែល​អាជីវកម្ម​របស់អ្នកមាន និង​មិនទាន់មាន? | What type of relationship does each of our Customer Segments expect us to establish and maintain with them?<br>តើប្រភេទទំនាក់ទំនងទាំងនោះមានអន្តរកម្មយ៉ាងដូចម្តេចជាមួយ គំរូអាជីវកម្ម (BMC) ទាំងមូលរបស់យើង? |  Which ones have we established? How are they integrated with the rest of our business model?<br>អ្នកត្រូវចំនាយប៉ុន្មាន ដើម្បីបង្កើតទំនាក់ទំនងទាំងនោះ? How costly are they?"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-channels",
          title: "បណ្តាញដើម្បីឈានទៅកាន់អតិថិជន |  Channels",
          description: {
            title:
              "តើ​ប្រភេទអតិថិជន​នីមួយៗរបស់យើងចង់ឲ្យ​យើងទាក់ទង ទៅពួកគេដោយរបៀបណា? Through which Channels do our Customer Segments want to be reached?<br>តើពួកយើងកំពុង​ទាក់ទងទៅពួកគេដោយរបៀបណា? How are we reaching them now?<br>តើបណ្តាញដើម្បីឈានទៅកាន់​អតិថិជនរបស់យើង មានអន្តរកម្មយ៉ាងដូចម្តេច?How are our Channels integrated?<br>តើ​បណ្តាញមួយណាដែល​មានប្រសិទ្ធភាពជាងគេ? Which ones works best?<br>តើបណ្តាញមួយណាដែលយើង​ចំនាយអស់តិចជាងគេ? Which ones are the most cost-efficient?<br>តើយើងត្រូវ​ធ្វើដូចម្តេចខ្លះដើម្បីឲ្យបណ្តាញទាំងនេះស្របគ្នាជាមួយ ទម្លាប់អតិថិជន? How are we integrating them with customer routines?"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-customer-segments",
          title: "ប្រភេទអតិថិជន |  Customer Segments",
          description: {
            title:
              "តើអ្នកណាខ្លះជា​អតិថិជនរបស់យើង? For whom are we creating value?<br>តើអ្នកណាខ្លះជាអតិថិជនសំខាន់បំផុតរបស់យើង? Who are our most important customers?<br>ការបែងចែកប្រភេទអតិថិជន​មាន​ដូចជា៖ ទីផ្សារទូលំទូលាយ (Mass Market) ទីផ្សារពិសេស (Niche Market)  ចំណែកទីផ្សារ (Segmented) ភាពចម្រុះនៃទីផ្សារ (Diversified) ទីផ្សារពហុផ្នែក (Multi-sided Platform)"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-cost-structure",
          title: "រចនាសម្ព័ន្ធនៃថ្លៃដើម  | Cost Structure",
          description: {
            title:
              "តើថ្លៃដើមអ្វីដែល​សំខាន់បំផុត​ក្នុង​គំរូអាជីវកម្មរបស់យើង? What are the most important costs inherent in the business mode?<br>តើធនធានសំខាន់ៗអ្វីខ្លះដែល​មានតម្លៃថ្លៃបំផុត? Which key resources are the most expensive?<br>តើ​សកម្មភាព​សំខាន់ៗណាខ្លះដែលយើងត្រូវចំណាយច្រើនបំផុត? Which key activities are the most expensive?<br>តើអាជីវកម្មរបស់អ្នកជាប្រភេទអាជីវកម្មដែល៖ Is your business more:<br>យក​ថ្លៃដើមជាធំ (កាត់បន្ថយថ្លៃដើម, យក​តម្លៃថោកជាលក្ខណៈពិសេស, ស្វ័យប្រវត្តិកម្មជា​អតិបរិមា, ជួលអ្នកដទៃឲ្យ​ផលិតផលិតផល ឬ​ផ្តល់សេវាកម្មអ្វីមួយជំនួសអ្នក) Cost Driven ( leanest cost structure, low price value proposition, maximum automation, extensive outsourcing<br>យកគុណតម្លៃជាធំ (ផ្តោតសំខាន់លើ​ការបង្កើនទាំងចំនួន និងគុណភាពនៃគុណតម្លៃអាជីវកម្ម) Value Driven (focused on value creation, premium value proposition)<br>គំរូនៃលក្ខណៈថ្លៃដើមមានដូចជា៖ Multiple Characteristics: <br>ការ​ចំនាយថេរ (ប្រាក់ខែបុគ្គលិក, ថ្លៃជួល, ទឹកភ្លើង) Fixed Costs (Salaries, rent, utilities) | ការចំនាយប្រែប្រួល (Variable costs)<br>ការសន្សំសំចៃពីការ​បង្កើនបរិមាណផលិតកម្ម (Economies of Scale) | ការសន្សំសំចៃពីការផលិត​ផលិតផលពីរ ឬច្រើនផ្សេងគ្នា (Economies of Scope)"
          }
        },
        {
          id: routes.BUSINESS_MODEL_CANVAS + "-cost-revenue",
          title: "លំហូនៃប្រាក់ចំណូល | Revenue",
          description: {
            title:
              "អតិថិជនរបស់យើង​ពេញចិត្តនឹងចំនាយទៅលើគុណតម្លៃអ្វី? For what value are customers willing to pay?<br>ពួកគេចំនាយលើគុណតម្លៃអ្វីនាពេលបច្ចុប្បន្ន? For what do they currently pay?<br>ពួកគេចំនាយដោយរបៀបណានាពេលបច្ចុប្បន្ន? How are they currently paying?<br>ពួកគេចង់ចំនាយដោយ​របៀបណាជាង? How would they prefer to pay?<br>លំហូចំនូលនីមួយៗរួមចំណែកប៉ុន្មានទៅចំនូលសរុប? How much does each Revenue Streams contribute to overall revenues?<br>លំហូនៃប្រាក់ចំណូលមានដូចជា Types of Revenue Streams ៖ ",
            subDescription: [
              {
                title: "ការលក់ទ្រព្យ Asset Sales",
                description:
                  "កម្រៃបានពីការទិញរបស់អតិថិជន Usage Fee<br>កម្រៃនៃការជាវជាប្រចាំរបស់អតិថិជន Subscription Fee<br>ចំណូលពីការផ្តល់ប្រាក់កម្ចី ការជួលអចលនទ្រព្យរយៈពេលខ្លី ឬ​រយៈពេលវែង Lending, Renting or Leasing<br>ចំណូលពីការផ្តល់អាជ្ញាប័ណ្ណ Licensing<br>កម្រៃពីការធ្វើជាឈ្មួញកណ្តាល Brokerage fees<br>ចំណូលពីការផ្តល់សេវាផ្សាយពាណិជ្ជកម្ម Advertising"
              },
              {
                title: "តម្លៃលក់ថេរ | FIXED PRICING",
                description:
                  "តម្លៃលក់ស្របតាមបញ្ជីរាយតម្លៃ List Price<br>តម្លៃលក់ទៅតាមការបន្ថែមលក្ខណៈពិសេសនៃផលិតផល Product feature dependent<br> តម្លៃលក់ទៅតាមប្រភេទអតិថិជន Customer Segment dependen<br>តម្លៃលក់ទៅតាមបរិមាណនៃការទិញ Volume dependent"
              },
              {
                title: "តម្លៃលក់ប្រែប្រួល | DYNAMIC PRICING",
                description:
                  "តម្លៃលក់ទៅតាមការតថ្លៃ Negotiating (bargaining)<br>តម្លៃលក់ទៅតាមទំហំតម្រូវការ ឬទំហំទិន្នផល(Yield Management)<br>តម្លៃលក់ទៅតាមតម្លៃទីផ្សារជាក់ស្តែង (Real-time Market)"
              }
            ]
          }
        }
      ]
    },
    {
      id: routes.REFLECTION_CANVAS,
      // image: images.TEAM_REFLECTION_IMAGE,
      en_name: "Team Reflection Canvas",
      kh_name: "សន្លឹកកិច្ចការឆ្លុះបញ្ចាំងនូវអ្វែដែលបានរៀន",
      en_short_description:
        "Learning from past experiences is one of the most important ways to learn like an entrepreneur. Reflect here with your team to benefit in the future.",
      kh_short_description:
        "ការរៀនសូត្រពីបទពិសោធន៍កន្លងមកគឺជា​មធ្យោបាយដ៏សំខាន់បំផុតដើម្បីក្លាយខ្លួនជាសហគ្រិន។ ធ្វើការឆ្លុះបញ្ចាងជាមួយក្រុមការងាររបស់អ្នកដើម្បីទទួលបាន​អត្ថប្រយោជន៍នាពេលអនាគត។",
      en_description:
        "Learning from past experiences is one of the most important ways to learn like an entrepreneur. Reflect here with your team to benefit in the future.",
      kh_description:
        "ការរៀនសូត្រពីបទពិសោធន៍កន្លងមកគឺជា​មធ្យោបាយដ៏សំខាន់បំផុតដើម្បីក្លាយខ្លួនជាសហគ្រិន។ ធ្វើការឆ្លុះបញ្ចាងជាមួយក្រុមការងាររបស់អ្នកដើម្បីទទួលបាន​អត្ថប្រយោជន៍នាពេលអនាគត។",
      blocks: [
        {
          id: routes.REFLECTION_CANVAS + "section-00",
          title: "តើការធ្វើការលើគំនិតនេះ មានចំណុចល្អអ្វីខ្លះ?"
        },
        {
          id: routes.REFLECTION_CANVAS + "section-01",
          title: "តើចំណុចអ្វីខ្លះគួរកែតម្រូវ? ដោយរបៀបណា?"
        },
        {
          id: routes.REFLECTION_CANVAS + "section-02",
          title: "តើអ្នករៀនបានអ្វីខ្លះពីការេធ្វើការជាមួយក្រុមដទៃ?"
        }
      ]
    }
  ]
};

const findCanvas = (state, action) => {
  let foundCanvas = R.find(R.propEq("id", action.canvasId))(state.canvases);
  return { ...state, canvas: foundCanvas };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CANVAS_SET_CANVASES:
      return { ...state, canvases: action.canvases, loading: true, error: "" };
    case actionTypes.CANVAS_SET_CANVASES_SUCCESS:
      return { ...state, canvases: action.canvases, loading: false, error: "" };
    case actionTypes.CANVAS_SET_CANVASES_ERROR:
      return { ...state, loading: false, error: action.message };
    case actionTypes.CANVAS_SET_CANVAS:
      return { ...state, canvas: action.canvas };
    case actionTypes.CANVAS_SET_FIND_CANVAS:
      return findCanvas(state, action);
    default:
      return state;
  }
};

export default reducer;
